<template>
  <div style="background-color: white">
    <div class="lightbox">
      <div id="SliderTop">
        <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
      </div>
      <h1>名片模式</h1>
      <p class="my-3">&nbsp;</p>
      <div class="d-flex">
        <div>
          <form
            action="/apiExhibitors/ExportExcel/"
            method="post"
            enctype="multipart/form-data"
          >
            <input type="hidden" name="RegNo" :value="`${RegNo}`" />
            <input type="hidden" name="CSRF" :value="`${CSRF_Token}`" />

            <button class="btnStyle" type="submit">匯出Excel</button>
          </form>
        </div>

        <div>
          <a
            href="#"
            class="btnStyle NoShowInMobile ml-2"
            @click="toUpgradeGetList"
            >列表模式</a
          >
        </div>
      </div>
      <p class="my-3">&nbsp;</p>

      <div class="cardMode"></div>
      <div class="cardType">
        <div class="row">
          <div
            class="col-sm-3 mb-2"
            v-for="(item, index) in buyersCard"
            :key="index"
          >
            <div class="card mt-3">
              <div class="card-body">
                <div class="card-header" style="font-weight: bold">
                  No. {{ item.No }}
                </div>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <div>
                      <span class="font-weight-bold">買主名稱 :</span>
                      {{ item.BuyerName }}
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div>
                      <span class="font-weight-bold">Mobile :</span>
                      {{ item.BuyerMobile }}
                    </div>
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">Email :</span>
                    {{ item.BuyerEmail }}
                  </li>
                  <li class="list-group-item">
                    <span class="font-weight-bold">掃描時間 : </span
                    >{{ item.CreateTime }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="PcDevice">
          <div v-if="totalPage > 1" class="mt-5 d-flex justify-content-center">
            <nav>
              <ul class="pagination">
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == 0 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Previous"
                    @click="returntenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-left"></i
                    ></span>
                  </a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Previous"
                    @click="lastPage()"
                  >
                    <span aria-hidden="true">
                      <i class="fas fa-angle-left"></i>
                    </span>
                  </a>
                </li>
                <li
                  class="page-item"
                  v-for="page in showpage"
                  :key="page"
                  :class="{ active: currentPage == page }"
                >
                  <a class="page-link" href="#" @click="getPage(page)">{{
                    page
                  }}</a>
                </li>

                <li
                  class="page-item"
                  :class="{ disabled: currentPage == totalPage }"
                >
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Next"
                    @click="nextPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-right"></i
                    ></span>
                  </a>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Next"
                    @click="nexttenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-right"></i
                    ></span>
                  </a>
                </li>
              </ul>
              <p class="text-center mt-1" style="font-size: 10px">
                第 {{ currentPage }} / {{ totalPage }}
                頁
              </p>
            </nav>
          </div>
        </div>

        <div class="MbDevice">
          <div v-if="totalPage > 1" class="mt-3 d-flex justify-content-center">
            <nav>
              <ul class="pagination pagination-sm">
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == 0 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Previous"
                    @click="returntenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-left"></i
                    ></span>
                  </a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Previous"
                    @click="lastPage()"
                  >
                    <span aria-hidden="true">
                      <i class="fas fa-angle-left"></i>
                    </span>
                  </a>
                </li>
                <li
                  class="page-item"
                  v-for="page in showpage"
                  :key="page"
                  :class="{ active: currentPage == page }"
                >
                  <a class="page-link" href="#" @click="getPage(page)">{{
                    page
                  }}</a>
                </li>

                <li
                  class="page-item"
                  :class="{ disabled: currentPage == totalPage }"
                >
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Next"
                    @click="nextPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-right"></i
                    ></span>
                  </a>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <a
                    class="page-link"
                    href="#"
                    aria-label="Next"
                    @click="nexttenPage()"
                  >
                    <span aria-hidden="true"
                      ><i class="fas fa-angle-double-right"></i
                    ></span>
                  </a>
                </li>
              </ul>
              <p class="text-center mt-1" style="font-size: 10px">
                第 {{ currentPage }} / {{ totalPage }}
                頁
              </p>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  data() {
    return {
      CSRF_Token: "",
      RegNo: "",
      PageSize: 1,
      buyersCard: [], //ok
      totalPage: "",
      totalNo: "",
      currentPage: 1,
      buyerRawData: [], //rawData
      totaltenPageNum: "", //共幾筆十頁

      showpage: [],
      tenPageNum: "",
    };
  },
  methods: {
    toUpgradeGetList() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeGetList?no=${vm.RegNo}`;
    },

    toUpgradeGetCard() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeGetCard?no=${vm.RegNo}`;
    },

    getPage(page) {
      const vm = this;
      vm.currentPage = page;
      vm.newPageApi();
    },

    nextPage() {
      const vm = this;

      vm.currentPage = Number(vm.currentPage) + 1;
      vm.newPageApi();
    },

    lastPage() {
      const vm = this;

      vm.currentPage = Number(vm.currentPage) - 1;
      vm.newPageApi();
    },

    nexttenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum + 1;
      vm.showpage = vm.inviteRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];
      vm.newPageApi();
    },

    returntenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum - 1;
      vm.showpage = vm.inviteRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];
      vm.newPageApi();
    },

    mainPageApi() {
      const vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/buyers/${vm.RegNo}?Page=${vm.currentPage}`
        )
        .then((response) => {
          if (response.data.pagetotal > 0) {
            vm.buyersCard = response.data.Data;
            vm.totalPage = response.data.pagetotal;
            vm.totalNo = response.data.datatotal;

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.buyerRawData.push([]);
              }

              const page = parseInt(i / 10); //parseInt整數公式
              vm.buyerRawData[page].push(i + 1);
            }

            //totaltenPageNum 取得共有幾筆十頁
            vm.totaltenPageNum = vm.buyerRawData.length;

            //從取得的筆數後，tenNum 計算出現第幾個十頁數

            let anaNowPage = vm.currentPage - 1; //判定第幾頁(十位)，頁數減一避免進位

            vm.tenPageNum = parseInt(anaNowPage / 10);
            vm.showpage = vm.buyerRawData[vm.tenPageNum];
          }
        });
    },

    newPageApi() {
      const vm = this;

      let url = `/apiExhibitors/buyers/${vm.RegNo}?Page=${vm.currentPage}`;

      axios.get(url).then(function (response) {
        vm.buyersCard = response.data.Data;

        let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

        vm.tenPageNum = parseInt(anaNowPage / 10);
        vm.showpage = vm.inviteRawData[vm.tenPageNum];
      });
    },

    ExportExcel() {
      const vm = this;

      let url = `/apiExhibitors/ExportExcel/`;
      let info = {
        RegNo: vm.RegNo,
        CSRF: vm.CSRF_Token,
      };
      axios.post(url, info).then(function (response) {});
    },
  },

  created() {
    const vm = this;

    $(() => {
      $("#SliderTop").click(() => {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

      $(window)
        .scroll(function () {
          if ($(this).scrollTop() > 300) {
            $("#SliderTop").fadeIn(222);
          } else {
            $("#SliderTop").stop().fadeOut(222);
          }
        })
        .scroll();
    });

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    vm.mainPageApi();
  },
};
</script>

<style lang="scss">
a:hover {
  color: #ffffff;
  text-decoration: none;
}

.list-group-item {
  padding: 0.4rem 0.8rem;
}

.card-body {
  padding: 0.5rem;
}

.card-header {
  padding: 0.35rem 0.8rem;
  margin-bottom: 0;
  background-color: #e9eef4;
  border-bottom: 0px;
}

body {
  background-color: rgb(255, 255, 255);
}
</style>
